

import CommonApi from './../commonApi';

const budgetVersion = new CommonApi(
  'budgetVersion',
  'Версии бюджета'
);

export default {
  ...budgetVersion
};
